import {combineReducers} from 'redux';
import BusCommon from './containers/Common/redux/reducers';
import Home from './containers/Home/redux/reducer';
import SRP from './containers/SRP/redux/reducer';
import SeatLayout from './containers/SeatLayout/redux/reducer';
import Review from './containers/Review/redux/reducer';
import Thankyou from './containers/ThankyouPage/redux/reducer';

const reducerList = {
  common:BusCommon,
  srp: SRP,
  seatLayout:SeatLayout,
  review:Review,
  home:Home,
  thankyou:Thankyou
};

export default reducerList;

const rootReducer = combineReducers(reducerList);

export type AppState = ReturnType<typeof rootReducer>;
